import React, { Component } from "react";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import {MISSED_INTENTS_ANALYSIS, MISSED_INTENTS_RESPONSES, NLU_MESSAGES, PROMPT_RESPONSES, PROMPT_HANGUP, SPEECH_RECOGNITION, PROMPT_OUTCOME, GRAMMAR_RESPONSES, SUCCESS} from './constants';
import {
  Row,
  Button,
  Card,
  CardBody,
  CardHeader,
  InputGroup,
  InputGroupAddon,
  Input,
  Col,
  ListGroupItem,
  Table
} from "reactstrap";
import queryString from "query-string";
import "./Reporting.scss";
const TIMEZONE_MAP = {'America/Chicago': 'CT', 'America/Denver': 'MT', 'America/New_York': 'ET', 'America/Los_Angeles': 'PT' }
var apiCalls = require("../../ApiCalls");
const moment = require('moment-timezone');
const _ = require('lodash');
const reportMap = {  
  [MISSED_INTENTS_ANALYSIS.id]: MISSED_INTENTS_ANALYSIS,
  [MISSED_INTENTS_RESPONSES.id]:MISSED_INTENTS_RESPONSES,
  [NLU_MESSAGES.id]:NLU_MESSAGES,
  [PROMPT_RESPONSES.id]:PROMPT_RESPONSES,
  [PROMPT_HANGUP.id]: PROMPT_HANGUP,
  [SPEECH_RECOGNITION.id]: SPEECH_RECOGNITION,
  [PROMPT_OUTCOME.id] : PROMPT_OUTCOME,
  [GRAMMAR_RESPONSES.id]: GRAMMAR_RESPONSES,
  [SUCCESS.id]: SUCCESS,
}
class Report extends Component {
  constructor(props){
    super(props);
    let queryValues = queryString.parse(this.props.location.search);
    this.exportCSV = this.exportCSV.bind(this);
    this.setColumnDef = this.setColumnDef.bind(this);
    this.setSortModel = this.setSortModel.bind(this);
    this.updateFilename = this.updateFilename.bind(this);
    this.displayQueryInfo = this.displayQueryInfo.bind(this);
    this.showModal = this.showModal.bind(this);
    this.getAudioField = this.getAudioField.bind(this)
    this.playButtonRenderer = this.playButtonRenderer.bind(this)
    this.formatTime = this.formatTime.bind(this);
    this.state = {
      title: this.props.match.params.type,
      reportType: this.props.match.params.type,
      generatedAt: queryValues.now,
      fileName:  reportMap[this.props.match.params.type].title.replaceAll(' ', '_') + '_' + moment(parseInt(queryValues.startAt)).format("YYYYMMDD") + "_" + moment(parseInt(queryValues.endAt)).format("MMDDYYYY"),
      startAt: queryValues.startAt,
      endAt: queryValues.endAt,
      prompt: queryValues.prompt,
      group: queryValues.promptGroup,
      channel: queryValues.channel,
      audioStorage: queryValues.audioStorage,
      promptsVersionId: queryValues.promptsVersionId,
      totalResults: 0,
      showModal: false,
      selectedPrompts: JSON.parse("[" + queryValues.selectedPrompts + "]"),
      promptNames: queryValues.promptNames.split(','),
      selectedChannels: JSON.parse("[" + queryValues.selectedChannels + "]"),
      channelNames: queryValues.channelNames.replace(/,/g, ', ') ,
      includeAudio: queryValues.audio === 'true',
      timezone:  queryValues.timezone,
      language: queryValues.language,

      selectedPromptName: "",
      selectedChannelName: "",
      filenameEditable: false,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        editable: true,
        autoHeight: true,
        cellClass: 'cell-wrap-text',
        flex: 1,
        timezone: queryValues.timezone
      },
      columnDefs: [],
      rowData: [],
      sortModel: [],
      prompts: [],
      channels: [],
      tooltipShowDelay: 0,
      hideReport: false,

      averageIVRTime: 0,
      totalCalls: 0,
      totalRow: null
    }
  }

  componentDidMount(){
    moment.tz.setDefault(this.state.timezone); 
    this.setTitle();
  }

  exportCSV(){
    var params = {
      fileName: `${this.state.fileName}.csv` ,
      processCellCallback: this.percentageCallback,
      audioMode: this.state.audioStorage,
      colDef:{
        timezone: this.state.timezone
      }
      
    }
    this.gridApi.exportDataAsCsv(params);
  }

  percentageCallback(params){
    let colDef = params.column.getColDef();
    if(colDef.valueFormatterName === "percentFormatter"){
      return percentFormatter(params);
    }
    else if(colDef.valueFormatterName === "dateFormatter"){
      return dateFormatter(params);
    }
    else if(colDef.valueFormatterName === "audioFormatter")
    {
     return audioFormatter(params)
    }
    else if(colDef.valueFormatterName === "audioFormatterPrism")
    {
     return audioFormatterPrism(params)
    }
    else {
      return params.value;
    }
  }

  getAudioField()
  {
    if(this.state.audioStorage === 'prism' )
    {
      return {field: 'recordingURL', valueFormatterName: "audioFormatterPrism", valueFormatter: audioFormatterPrism}
    }
    return {field: 'recordingId', valueFormatterName: "audioFormatter", valueFormatter: audioFormatter}
  }

  setColumnDef() {
    let reportColumnDefs = {
      [MISSED_INTENTS_ANALYSIS.id]: [
        {headerName: "Prompt Name", field: "promptName", headerTooltip: 'Prompt Name'},
        {headerName: "Prompt Text", field: "question", headerTooltip: 'Prompt Text'},
        {headerName: "Prompt Group", field: "group", headerTooltip: 'Prompt Group'},
        {headerName: "Total Invalid Responses", field: "numOfMissed", filter: 'agNumberColumnFilter', headerTooltip: 'Total Invalid Responses'},
        {headerName: "Total Valid Responses", field: "numOfHits", filter: 'agNumberColumnFilter', headerTooltip: 'Total Valid Responses'},
        {headerName: "Total Responses", field: "numOfResponses", filter: 'agNumberColumnFilter', headerTooltip: 'Total Responses'},
        {headerName: "Invalid Rate(%)", field: "missedRate", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'Invalid Rate(%)'},
        {headerName: "Valid Rate(%)", field: "hitRate", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'Valid Rate(%)'},
        {headerName: "Invalid User Responses", field: "missed", headerTooltip: 'Invalid User Responses'},
        {headerName: "Channels", field: "missedChannels", headerTooltip: 'Channels'},
        {headerName: "ASR Engine", field: "asrEngine", headerTooltip: 'Automatic Speech Recognition Engine'}
      ],
      [MISSED_INTENTS_RESPONSES.id]: [
        {headerName: "Conversation ID", field: "conversationId", cellRenderer: hrefCellRenderer, headerTooltip: 'Conversation ID'},
        {headerName: "Prompt Name", field: "promptName", headerTooltip: 'Prompt Name'},
        {headerName: "Bot Questions", field: "botQuestion", headerTooltip: 'Bot Questions'},
        {headerName: "Prompt Group", field: "group", headerTooltip: 'Prompt Group'},
        {headerName: "User Reponses", field: "userResponse", valueFormatter: emptyStringFormatter, headerTooltip: 'User Reponses'},
        {headerName: "Intent Confidence", field: "nluConfidence", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'Intent Confidence'},
        {headerName: "Timestamp", field: "timestamp", valueFormatter: dateFormatter, valueFormatterName:  "dateFormatter", headerTooltip: 'Timestamp'},
        {headerName: "Channel", field: "missedChannels", headerTooltip: 'Channel'},
        {headerName: "ASR Engine", field: "asrEngine", headerTooltip: 'Automatic Speech Recognition Engine'}
      ],
      [NLU_MESSAGES.id]: [
        {headerName: "Timestamp", field: "timestamp", valueFormatter: dateFormatter, valueFormatterName: "dateFormatter", headerTooltip: 'Timestamp'},
        {headerName: "Message", field: "message", valueFormatter: emptyStringFormatter, headerTooltip: 'Message'},
        {headerName: "NLU Confidence", field: "nluConfidence", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", headerTooltip: 'NLU Confidence'},
        {headerName: "Intent", field: "intent", valueFormatter: emptyStringFormatter, headerTooltip: 'Intent'},
      ],
      [PROMPT_RESPONSES.id]: [
        {headerName: "Prompt Name", field: "promptName", headerTooltip: 'Prompt Name'},
        {headerName: "Prompt Group", field: "groupName", headerTooltip: 'Prompt Group'},
        {headerName: "Prompt Text", field: "promptText", headerTooltip: 'Prompt Text'},
        {headerName: "User Response", field: "message", valueFormatter: emptyStringFormatter, headerTooltip: 'User Response'},
        {headerName: "Intent", field: "intent", valueFormatter: emptyStringFormatter, headerTooltip: 'Intent'},
        {headerName: "Valid Response", field: "validResponse", headerTooltip: 'Valid Response'},
        {headerName: "Intent Confidence", field: "nluConfidence", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'Intent Confidence'},
        {headerName: "ASR Confidence", field: "asrConfidence", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'ASR Confidence'},
        {headerName: "Channel", field: "channelName",  cellRenderer: emptyStringFormatter, headerTooltip: 'Channel'},
        {headerName: "Conversation ID", field: "conversationId",  cellRenderer: hrefCellRenderer, headerTooltip: 'Conversation ID'},
        {headerName: "Timestamp", field: "timestamp", valueFormatter: dateFormatter, valueFormatterName:  "dateFormatter", headerTooltip: 'Timestamp'},
        {headerName: "Input Mode", field: "messageType", valueFormatter: emptyStringFormatter, headerTooltip: 'Input Mode'},
        {headerName: "Audio",  field: this.getAudioField().field , valueFormatter: this.getAudioField().valueFormatter, valueFormatterName: this.getAudioField().valueFormatterName, cellRenderer: this.playButtonRenderer, headerTooltip: 'Audio'},
        {headerName: "Unredacted Audio URL", field: "unredactedRecordingURL",  cellRenderer: emptyStringFormatter, headerTooltip: "Unredacted Audio URL"},
        {headerName: "Unredacted MRCP URL", field: "unredactedTranscriptURL",  cellRenderer: emptyStringFormatter, headerTooltip: "Unredacted Response Data"},
        {headerName: "DNIS", field: "dnis",  cellRenderer: emptyStringFormatter, headerTooltip: "DNIS"},
        {headerName: "Data Center", field: "dataCenter", headerTooltip: "Data Center"}
      ],
      [GRAMMAR_RESPONSES.id]: [
        {headerName: "Prompt Name", field: "promptName", headerTooltip: 'Prompt Name'},
        {headerName: "Prompt Text", field: "promptText", headerTooltip: 'Prompt Text'},
        {headerName: "Dialog Group", field: "groupName", headerTooltip: 'Dialog Group'},
        {headerName: "Grammar File", field: "promptGrammar", headerTooltip: 'Grammar File'},
        {headerName: "User Response", field: "grammarUtterance", valueFormatter: emptyStringFormatter, headerTooltip: 'User Response'},
        {headerName: "Confidence", field: "asrConfidence", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'Confidence'},
        {headerName: "Valid Response", field: "validResponse", headerTooltip: 'Valid Response'},
        {headerName: "Error", field: "error_message", headerTooltip: 'Valid Response'},
        {headerName: "Grammar Slot", field: "message", headerTooltip: 'Grammar Slot'},
        {headerName: "Grammar File Used", field: "matchedGrammarFile", headerTooltip: 'Grammar File Used'},
        {headerName: "Input Mode", field: "grammarMode", valueFormatter: emptyStringFormatter, headerTooltip: 'Input Mode'},
        {headerName: "Channel", field: "channelName",  cellRenderer: emptyStringFormatter, headerTooltip: 'Channel'},
        {headerName: "Conversation ID", field: "conversationId",  cellRenderer: hrefCellRenderer, headerTooltip: 'Conversation ID'},
        {headerName: "Timestamp", field: "timestamp", valueFormatter: dateFormatter, valueFormatterName:  "dateFormatter", headerTooltip: 'Timestamp'},
        {headerName: "Audio",  field: this.getAudioField().field , valueFormatter: this.getAudioField().valueFormatter, valueFormatterName: this.getAudioField().valueFormatterName, cellRenderer: this.playButtonRenderer, headerTooltip: 'Audio'},
        {headerName: "Unredacted Audio URL", field: "unredactedRecordingURL",  cellRenderer: emptyStringFormatter, headerTooltip: "Unredacted Audio URL"},
        {headerName: "Unredacted MRCP URL", field: "unredactedTranscriptURL",  cellRenderer: emptyStringFormatter, headerTooltip: "Unredacted Response Data"},
        {headerName: "Data Center", field: "dataCenter", headerTooltip: "Data Center"}
      ],
      [PROMPT_HANGUP.id]: [
        {headerName: "Prompt Name", field: "promptName", valueFormatter: emptyStringFormatter, headerTooltip: 'Prompt Name'},
        {headerName: "Prompt Group", field: "group", headerTooltip: 'Prompt Group'},
        {headerName: "OMNI_WEBCHAT_00001", field: "OMNI_WEBCHAT_00001", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'OMNI_WEBCHAT_00001'},
        {headerName: "OMNI_VOICE_00001", field: "OMNI_VOICE_00001", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'OMNI_VOICE_00001'},
        {headerName: "OMNI_IOSAPP_00001", field: "OMNI_IOSAPP_00001", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'OMNI_IOSAPP_00001'},
        {headerName: "OMNI_FACEBOOK_0001", field: "OMNI_FACEBOOK_00001", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'OMNI_FACEBOOK_0001'},
        {headerName: "OMNI_SMS_00001", field: "OMNI_SMS_00001", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'OMNI_SMS_00001'},
        {headerName: "Overall Disconnect Rate", field: "promptDisconnectRate", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'Overall Disconnect Rate'},
      ],
      [SPEECH_RECOGNITION.id]: [
        {headerName: "Prompt Name", field: "promptName", headerTooltip: 'Prompt Name'},
        {headerName: "Prompt Text", field: "question", valueFormatter: emptyStringFormatter, headerTooltip: 'Prompt Text'},
        {headerName: "Prompt Group", field: "group", headerTooltip: 'Prompt Group'},
        {headerName: "Average Recognized Confidence", field: "validAverageConfidence", valueFormatter: asrReportFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Average Recognized Confidence'},
        {headerName: "Min Recognized Confidence", field: "validMin", valueFormatter: asrReportFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Min Recognized Confidence'},
        {headerName: "Max Recognized Confidence", field: "validMax", valueFormatter: asrReportFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Max Recognized Confidence'},
        {headerName: "Average Unrecognized Confidence", field: "invalidAverageConfidence", valueFormatter: asrReportFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Average Unrecognized Confidence'},
        {headerName: "Min Unrecognized Confidence", field: "invalidMin", valueFormatter: asrReportFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Min Unrecognized Confidence'},
        {headerName: "Max Unrecognized Confidence", field: "invalidMax", valueFormatter: asrReportFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Max Unrecognized Confidence'},
      ],
      [PROMPT_OUTCOME.id]: [
        {headerName: "Prompt Name", field: "promptName", headerTooltip: 'Prompt Name'},
        {headerName: "Prompt Text", field: "question", valueFormatter: emptyStringFormatter, headerTooltip: 'Prompt Text'},
        {headerName: "Prompt Group", field: "group", headerTooltip: 'Prompt Group'},
        {headerName: "Total Occurrences", field: "totalOccurrences", valueFormatter: emptyStringFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Total Occurrences'},
        {headerName: "Valid", field: "validOutcome", valueFormatter: emptyStringFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Valid'},
        {headerName: "Invalid ASR", field: "asrMiss", valueFormatter: emptyStringFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Invalid ASR'},
        {headerName: "Invalid NLU", field: "nluMiss", valueFormatter: emptyStringFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Invalid NLU'},
        {headerName: "No Input", field: "noInputHit", valueFormatter: emptyStringFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'No Input'},
        {headerName: "Disconnects", field: "hangupHit", valueFormatter: emptyStringFormatter, filter: 'agNumberColumnFilter', headerTooltip: 'Disconnects'},
        {headerName: "Success Rate", field: "successRate", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter", filter: 'agNumberColumnFilter', headerTooltip: 'Success Rate'}
      ],
      [SUCCESS.id]: [
        {headerName: "Activity", field: "activity", headerTooltip: "Activity Name"},
        {headerName: "Success", field: "success", headerTooltip: "Number of Successful Activities"},
        {headerName: "Total", field: "total", headerTooltip: "Total number of times activity was started"}, 
        {headerName: "Percentage", field: "percentage", headerTooltip: "Percent successful activities", valueFormatter: percentFormatter, valueFormatterName: "percentFormatter"}
      ]
    };

    let headers = reportColumnDefs[this.state.reportType]
    let userRole = window.sessionStorage.getItem("userRole")
    if(this.state.reportType === PROMPT_RESPONSES.id && ["admin","designer"].includes(userRole)){
      const additionalHeaders = [
        {headerName: "Matched Partial", field: "matchedPartial", valueFormatter: emptyStringFormatter, headerTooltip: 'Matched Partial'},
        {headerName: "Original Transcription", field: "original_text", valueFormatter: emptyStringFormatter, headerTooltip: 'Original Transcription'},
        {headerName: "Partials", field: "partials", valueFormatter: emptyStringFormatter, headerTooltip: 'Partials'},
        {headerName: "Partials Processed", field: "partialsProcessed", valueFormatter: numberFormatter, headerTooltip: 'Number of Partials Processed'},
      ]
      headers.splice(headers.length -1,0, ...additionalHeaders)
    }


    this.setState({
      columnDefs: headers
    });
  }

  setTitle(){
    if(this.state.reportType === SPEECH_RECOGNITION.id){
      this.setState({title: SPEECH_RECOGNITION.title})
    }else if(this.state.reportType === SUCCESS.id){
      this.setState({title: SUCCESS.title})
    }else if(this.state.reportType === MISSED_INTENTS_ANALYSIS.id){
      this.setState({title: MISSED_INTENTS_ANALYSIS.title})
    }else if(this.state.reportType === PROMPT_OUTCOME.id){
      this.setState({title: PROMPT_OUTCOME.title})
    }
  }

  setSortModel(){
    let defaultSortModel = {
      [MISSED_INTENTS_ANALYSIS.id]: [
        {colId: 'missedRate', sort: 'desc'}
      ],
      [MISSED_INTENTS_RESPONSES.id]: [
        {colId: 'timestamp', sort: 'desc'}
      ],
      [PROMPT_RESPONSES.id]: [
        {colId: 'timestamp', sort: 'desc'}
      ]
    }

    this.setState({sortModel: defaultSortModel[this.state.reportType]});
  }

  onGridReady = params => {
    this.setColumnDef();
    this.setSortModel();
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridOptions = params.gridOptions;
    this.gridApi.showLoadingOverlay();
    let queryParams = {
      startAt: this.state.startAt,
      endAt: this.state.endAt,
      prompt: this.state.prompt,
      prompts: this.state.selectedPrompts,
      channel: this.state.channel,
      channels: this.state.selectedChannels,
      audioStorage: this.state.audioStorage,
      promptsVersionId: this.state.promptsVersionId,
      includeAudio: this.state.includeAudio,
      promptNames: this.state.promptNames,
      language: this.state.language
    };

    apiCalls.getReport(this.state.reportType, queryParams).then(
       result => {
        if(result){
          if(result.results) {
            if(result.results.length > 0) {
              this.setState({
                rowData: result.results,
                totalResults: result.results.length
              }, function(){
                this.gridApi.sizeColumnsToFit();
                this.gridApi.setSortModel(this.state.sortModel);
              });
              if (this.state.reportType === SUCCESS.id) {
                this.setState({
                  totalCalls: result.topStats[0]['totalCalls'],
                  averageIVRTime: result.topStats[0]['avgTime'],
                  totalRow: result.results.slice(-1),
                  rowData: result.results.slice(0, -1),
                })
              }
            } else {
              this.gridApi.showNoRowsOverlay();
            }
          } else {
            this.setState({hideReport: true})
          }
        }
        else{
          this.setState({hideReport: true})
        }
      })
      .catch(() => {
        this.setState({hideReport: true})
      })
  }

  updateFilename(event) {
    this.setState({fileName: event.target.value});
  }

  /**
   * 
   * @param {number} timestamp - unix timestamp
   * @param {string} format - format of the date time
   * @returns {string} - Formatted date time
   */
  formatTime(timestamp, format="MM/DD/YYYY, h:mm A") {
    return moment.tz(parseInt(timestamp), this.state.timezone).format(format);
  }

  displayQueryInfo() {
    return ([
      <h6 key={1}><b>Date Range ({TIMEZONE_MAP[this.state.timezone]}:</b> {this.formatTime(this.state.startAt)} - {this.formatTime(this.state.endAt)}</h6>,
      <h6 key={2}><b>Channels:</b> {this.state.channelNames}</h6>,
      <h6 key={3}><b>Language:</b> {this.state.language}</h6>,
      <h6 key={4}><b>Prompts:</b> {this.state.promptNames.join(', ')}</h6>,
      <h6 key={5} hidden={this.state.group === 'null'}><b>Group:</b> {this.state.group}</h6>,
    ])
  }



  getDescription() {
    let title = _.startCase(this.state.reportType)
    if (this.state.reportType === MISSED_INTENTS_ANALYSIS.id) {
      return [
        <p key="1">The Missed Intent Analysis report provides aggregate metrics on user responses to prompts that failed or passed when trying to be matched to a trained Intent. </p>,
        <p key="2"><b>Prompt Name</b>: Name of the prompt sent by the Intelligent Assistant that the user response is associated with</p>,
        <p key="3"><b>Prompt Text</b>: Message text from the Intelligent Assistant that the user response is associated with</p>,
        <p key="4"><b>Prompt Group</b>: Group to which the prompt has been assigned</p>,
        <p key="5"><b>Total Invalid Responses</b>: Total number of user inputs associated with the Intelligent Assistant prompt that were not able to be matched to an Intent or produced an invalid speech recognition grammar result</p>,
        <p key="6"><b>Total Valid Responses</b>: Total number of user inputs associated with the Intelligent Assistant prompt that were able to be matched to an Intent or produced a valid speech recognition grammar result</p>,
        <p key="7"><b>Total Responses</b>: Total number of all user inputs associated with the Intelligent Assistant prompt</p>,
        <p key="8"><b>Invalid Rate:</b>: How often the user response is invalid (percentage), in reference to the associated Intelligent Assistant prompt, based on dividing invalid user responses by the total number of user responses </p>,
        <p key="9"><b>Valid Rate:</b>: How often the user response is valid (percentage), in reference to the associated assistant prompt, based on dividing valid user responses by the total number of user responses </p>,
        <p key="10"><b>Invalid User Responses:</b>: List of the invalid user input values associated with the corresponding Intelligent Assistant prompt</p>,
        <p key="11"><b>Channels</b>: The channels from which user input was receieved, whether valid or invalid, for the associated prompt</p>
      ]
    }
    else if (this.state.reportType === MISSED_INTENTS_RESPONSES.id) {
      return [
        <p key="1">The Missed Intent Responses report provides metrics on individual user input that failed to be matched to any trained Intent.</p>,
        <p key="2"><b>Conversation ID</b>: Unique ID that Links to the corresponding conversation</p>,
        <p key="3"><b>Prompt Name</b>: Name of the prompt sent by the Intelligent Assistant that the user response is associated with</p>,
        <p key="4"><b>Prompt Text</b>: Message text from the Intelligent Assistant that the user response is associated with</p>,
        <p key="5"><b>Prompt Group</b>: Group to which the prompt has been assigned</p>,
        <p key="6"><b>User Response</b>: User input value associated with the corresponding Intelligent Assitant prompt</p>,
        <p key="7"><b>Intent Confidence</b>: How confident the Intelligent Assistant was in regards to matching the user input to a trained Intent</p>,
        <p key="8"><b>Timestamp</b>: The date and time that the user input was received by the Intelligent Assistant</p>,
        <p key="9"><b>Channel</b>: The channel from which the user input was receieved</p>
      ]
    }
    else if (this.state.reportType === NLU_MESSAGES.id) {
      return <p key="1"><b>{title}</b>: Shows the record of messages and the Versay Intelligent Assistant interpretation of the user's intent</p>
    }
    else if (this.state.reportType === PROMPT_RESPONSES.id) {
      return [
        <p key="1">The Prompt Responses report provides metrics on individual user input associated with the selected prompt.</p>,
        <p key="2"><b>Prompt Name</b>: Name of the prompt sent by the Intelligent Assistant that the user response is associated with</p>,
        <p key="3"><b>Dialog Group</b>: Group to which the prompt has been assigned</p>,
        <p key="4"><b>Prompt Text</b>: What the chatbot says to the caller</p>,
        <p key="5"><b>User Response</b>: User input value associated with the selected Intelligent Assitant prompt</p>,
        <p key="6"><b>Intent</b>: User's intent predicted by Intelligent Assistant if a prediction was generated</p>,
        <p key="7"><b>Valid Response</b>: True/False value indicating whether the user input matched a trained Intent or user input resulted in a valid speech recognition grammar result</p>,
        <p key="8"><b>Intent Confidence</b>: How confident the Intelligent Assistant was in regards to matching the user input to a trained Intent</p>,
        <p key="9"><b>ASR Confidence</b>: How condifent the Intelligent Assistant was in regards to transcribing the user's audio input (audio channels only)</p>,
        <p key="10"><b>Channel</b>: The channel from which the user input was receieved</p>,
        <p key="11"><b>conversationId</b>: Link to full conversation</p>,
        <p key="12"><b>Timestamp</b>: Time prompt occurred</p>,
        <p key="13"><b>Input Mode</b>: Type of user response</p>,
        <p key="14"><b>Audio</b>: Redacted recording of user response if it exists</p>,
        <p key="15"><b>Unredacted Audio URL</b>: URL for the non-redacted recording version of the users response</p>,
        <p key="16"><b>Unredacted Transcript URL</b>: URL for the non-redacted users response</p>,
        <p key="17"><b>DNIS</b>: The DNIS the customer called.</p>
      ]
    }
    else if (this.state.reportType === GRAMMAR_RESPONSES.id) {
      return [
        <p key="1">The Prompt Responses report provides metrics on individual user input associated with the selected prompt.</p>,
        <p key="2"><b>Prompt Name</b>: Name of the prompt sent by the Intelligent Assistant that the user response is associated with</p>,
        <p key="3"><b>Prompt Text</b>: What the chatbot says to the caller</p>,
        <p key="4"><b>Dialog Group</b>: Group to which the prompt has been assigned</p>,
        <p key="5"><b>Grammar File</b>: Grammar files used by the chatbot to match with user's response</p>,
        <p key="6"><b>User Response</b>: User input value associated with the selected Intelligent Assitant prompt</p>,
        <p key="7"><b>Confidence</b>: How confident the Intelligent Assistant was in regards to matching the user input to a grammar result</p>,
        <p key="8"><b>Valid Response</b>: True/False value indicating whether a valid grammar result was generated</p>,
        <p key="9"><b>Error</b>: Type of error that occurred if response was invalid</p>,
        <p key="10"><b>Channel</b>: The channel from which the user input was receieved</p>,
        <p key="11"><b>Grammar Slot</b>: Value in grammar filed user response matched to</p>,
        <p key="12"><b>Matched Grammar File</b>: Grammar file Intelligent Assistant used to match user input with</p>,
        <p key="13"><b>Conversation Id</b>: Link to full conversation</p>,
        <p key="14"><b>Timestamp</b>: Time prompt occurred</p>,
        <p key="15"><b>Audio</b>: Redacted recording of user response if it exists</p>,
        <p key="16"><b>Unredacted Audio URL</b>: URL for the non-redacted recording version of the users response</p>,
        <p key="17"><b>Unredacted Transcript URL</b>: URL for the non-redacted users response</p>,
        <p key="18"><b>DNIS</b>: The DNIS the customer called.</p>
      ]
    }
    else if (this.state.reportType === PROMPT_HANGUP.id) {
      return [
        <p key="1">The Prompt Disconnect report shows metrics on prompts where users disconnected from the Intelligent Assistant without providing input.</p>,
        <p key="2"><b>Prompt Name</b>: Name of the prompt sent by the Intelligent Assistant that the user response is associated with</p>,
        <p key="3"><b>Prompt Group</b>: Group to which the prompt has been assigned</p>,
        <p key="4"><b>Overall Disconnect Rate</b>: How often a user disconnected without providing input, following the associated prompt. This is calculated by taking events where the user disconnects, without providing input, from the Intelligent Assistant when presented with the prompt, and dividing it by the total occurences of the prompt in all conversations</p>]
    }
    else if (this.state.reportType === SPEECH_RECOGNITION.id) {
      return [
        <p key="1"> The Speech recognition report provides metrics for the Versay Intelligent Assistant's audio speech recognition engine and its ability to transcribe user audio input. Fields with the value "NA" indicate a lack of data due user disconnect or no response.</p>,
        <p key="2"><b>Prompt Name</b>: Name of the prompt sent by the Intelligent Assistant that the user response is associated with.</p>,
        <p key="3"><b>Prompt Text</b>: Message from the Intelligent Assistant that the user response is associated with.</p>,
        <p key="4"><b>Prompt Group</b>: Group to which the prompt has been assigned</p>,
        <p key="5"><b>Average Recognized Confidence</b>: Percentage of all transcribed audio responses that meet the ASR confidence threshold.</p>,
        <p key="6"><b>Min Recognized Confidence</b>: Minimum recognized confidence rate.</p>,
        <p key="7"><b>Max Recognized Confidence</b>: Maximum recognized confidence rate.</p>,
        <p key="8"><b>Average Unrecognized Confidence</b>: Percentage of all transcribed audio responses that do not meet the ASR confidence threshold.</p>,
        <p key="9"><b>Min Unrecognized Confidence</b>: Minimum unrecognized confidence rate.</p>,
        <p key="10"><b>Max Unrecognized Confidence</b>: Maximum unrecognized confidence rate.</p>
      ]
    }
    else if (this.state.reportType === PROMPT_OUTCOME.id) {
      return [
        <p key="1">Provides metrics on the prompts that occurred.</p>,
        <p key="2"><b>Prompt Name</b>: Name of the prompt sent by the Intelligent Assistant that the user response is associated with</p>,
        <p key="3"><b>Prompt Text</b>: Message from the Intelligent Assistant that the user response is associated with</p>,
        <p key="4"><b>Prompt Group</b>: Group to which the prompt has been assigned</p>,
        <p key="5"><b>Total Occurrences</b>: Total user responses</p>,
        <p key="6"><b>Valid </b>: Number of user responses that either met the ASR and NLU confidence threshold or produced a valid speech recognition result</p>,
        <p key="7"><b>Invalid ASR</b>: Number of user responses that did not meet the ASR confidence threshold</p>,
        <p key="8"><b>Invalid NLU</b>: Number of user responses that did not meet the NLU confidence threshold</p>,
        <p key="9"><b>No Input</b>: Total user responses with no audio input recorded</p>,
        <p key="10"><b>Disconnect:</b>: Total occurrences of users disconnecting, rather than providing input</p>,
        <p key="11"><b>Success Rate:</b>: Overall percentage of user responses that met the ASR and NLU confidence threshold or produced a valid speech recognition grammar result</p>
      ]
    } else if (this.state.reportType === SUCCESS.id) {
     return [ 
        <p key="1">Provides metrics on event success and occurrences.</p>,
        <p key="3"><b>Activity</b>: IVR activity name</p>,
        <p key="4"><b>Success</b>: Total number of times activity was successful</p>,
        <p key="5"><b>Total</b>: Total number of times activity was started</p>,]
    }
  }

  showModal(){
    this.setState({showModal: !this.state.showModal})
  }

  playButtonRenderer(params)
  {
    if(params.value)
    {
        let url = this.state.audioStorage === 'prism' ? params.valueFormatted : `${apiCalls.getApiUrl()}/messages/recordings/${params.value}/stream`
        let eGui = document.createElement("div");
        eGui.style = "display:flex;"
        eGui.innerHTML = `<audio
        controls
        className="player"
        preload="false"
        ref="audio"
      >
        <source src=${url} />
      </audio>`;
        return eGui
    }
    else{
      let eGui = document.createElement("div");
      eGui.innerHTML = `<p>NA</p>`;
      return eGui
    }
  }

  render() {
    return(
      <div>
        <Card className="report-card">
          <CardHeader>
            <Row>
              <Col md="3">
                <header>
                  <h3>{this.state.title}</h3>
                </header>
              </Col>
              <Col md="4">
                <InputGroup>
                  <Input value={this.state.fileName} onChange={this.updateFilename}></Input>
                  <InputGroupAddon addonType="append">
                    <Button color="primary" size="md" onClick={this.exportCSV}>
                      Download
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
              <Col md={{size: 3, offset: 2}}>
                <Row>
                <span><b>Report generated at:</b> {moment.tz(parseInt(this.state.generatedAt), this.state.timezone).format("MM/DD/YYYY, h:mm A")}</span>
                </Row>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="report-card-body">
              <Row className="report-card-body-row">
                <Col >
                  <ListGroupItem className="report-card-body-lgi">
                    {this.displayQueryInfo()}
                  </ListGroupItem>
                </Col>
              </Row>
              <Row hidden={this.state.reportType !== SUCCESS.id || this.state.hideReport}>
                <Col>
                <Table hover
                       size={"sm"}>
                  <thead>
                    <tr>
                    <th>Top Level Stats</th>
                    <th></th>
                    <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th></th>
                      <th>Total Calls</th>
                      <th>{this.state.totalCalls}</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>Average Time In IVR</th>
                      <th>{new Date(this.state.averageIVRTime  * 1).toISOString().substr(14, 5)} m</th>
                    </tr>

                  </tbody>
                </Table>
                </Col>
              </Row>
              <Row>
                <Col>
                    <div className="ag-theme-balham" hidden={this.state.hideReport}>
                      <AgGridReact
                        rowSelection="multiple"
                        defaultColDef={this.state.defaultColDef}
                        columnDefs={this.state.columnDefs}
                        rowData={this.state.rowData}
                        onGridReady={this.onGridReady}
                        domLayout='autoHeight'
                        tooltipShowDelay={this.state.tooltipShowDelay}
                        pinnedBottomRowData={this.state.totalRow}
                      >
                      </AgGridReact>
                  </div>
                  <div className="ag-theme-balham" hidden={!this.state.hideReport}>
                    <p className="center-align">ERROR: Failed to retrieve report</p>
                  </div>
                </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    )
  }
}

function percentFormatter(params){
  if(params.value === undefined || params.value === null){
    return ("")
  }
  else{
    return ((params.value)).toFixed(2) + "%";
  }
}

function asrReportFormatter(params){
  if(params.value === null){
    return ("NA")
  }
  else{
    return ((params.value)).toFixed(2) + "%";
  }
}

function dateFormatter(params) {
  //set default
  let selTZ = 'America/Chicago'
  if(params.type === 'csv'){
    selTZ = params.column.colDef.timezone
  }
  else if (params.colDef){
    selTZ = params.colDef.timezone
  }
  return moment.tz(parseInt(params.value), selTZ).format("YYYY-MM-DD HH:mm:ss:SSS");
}

function emptyStringFormatter(params) {
  return (params.value === "" || params.value === undefined) ? "(blank)" : params.value;
}

function numberFormatter(params) {
  let result = parseInt(params.value)
  return isNaN(result) ? 0 : result;
}

function audioFormatter(params) {
  if(!params.value)
  {
    return ""
  }
  else
  {
    return  `${apiCalls.getUiUrl()}/recording/${params.value}`
  }
}

function audioFormatterPrism(params) {
  if(!params.value)
  {
    return ""
  }
  else
  {
    let prismStreamURL = `${apiCalls.getApiUrl()}/prism/stream?url=${params.value}`
    return  prismStreamURL ;
  }
}

function hrefCellRenderer(params) {
  let eGui = document.createElement("div");
  eGui.innerHTML = `<a href='#/conversations?conversationId=${params.value}'>${params.value}</a>`;
  eGui.addEventListener('click', function(event) {
    event.preventDefault();
    let conversationId = event.target.text;
    if(conversationId) {
      window.open(`#/conversations?conversationId=${conversationId}`);
    }
  });
  return eGui;
}

export default Report;
